<template>
    <!-- 学员信息 -->
    <div class="testContent">
        <div class="flex ai-c jc-sb searchBox">
            <div class="flex ai-c jc-sp col-2">
                <el-select class="mr-10" v-model="query.condition.status" :clearable="true" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-model="query.condition.keyword" class="mr-10" size="medium" placeholder="学员姓名/昵称" clearable></el-input>
                    <div class="flex aic-c ml-10">
                        <el-button @click="() => getStudentStudyListByCourse(query)" type="primary" icon="el-icon-search" plain>搜索</el-button>
                        <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
                    </div>
            </div>
            <div>
                <el-button @click="exportList" type="primary" plain icon="el-icon-download">导出学员信息</el-button>
            </div>
        </div>
        <el-table :data="testInfoList" v-loading="loading" border class="mt-20 table-fixed-col">
            <el-table-column label="序号" type="index" :index="indexFormatter" key="index" align="center" :width="getTableHeaderWidthByOrderCol()" fixed></el-table-column>
            <el-table-column label="昵称" prop="nickname" key="nickname" align="center" fixed min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.nickname + '（'+ scope.row.studentno +'）'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="姓名" key="studentname" prop="studentname" align="center"  min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="性别" prop="sexname" key="sexname" align="center"  min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="所在校区" prop="campusname" key="campusname" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="联系方式" prop="telno" key="telno" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="观看总时长" prop="totalstudytimes" key="totalstudytimes" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column label="课时完成进度" prop="studyrate" key="studyrate" align="center" min-width="120" show-overflow-tooltip></el-table-column> -->
             <el-table-column label="课时完成进度" prop="studyrate" key="studyrate" align="center" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.isfinishstudycount}}/{{scope.row.totalabcount}}</span>
                </template>
             </el-table-column>
            <el-table-column label="完课状态" prop="isfinishstudy" key="isfinishstudy" align="center" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="完成日期" prop="finfishtime" key="finfishtime" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="完成学分数" prop="score" key="score" align="center" min-width="120" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
            :hide-on-single-page="!total || total < 1"
            class="mt-20 flex ai-c jc-fd"
            @size-change="handePageSizeChange"
            @current-change="curPageChange"
            @prev-click="curPageChange"
            @next-click="curPageChange"
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="20"
            :current-page.sync="queryCache.page"
            background
        ></el-pagination>
    </div>
</template>
<script>
import { getStudentStudyListByCourse,exportStudentStudyList } from '@/api/measApi/teachManagement'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import { deepClone } from '@/common/js/tools'
export default {
    data () {
        return {
            total: 0,
            loading: false,
            testInfoList: [],
            query: {
                condition: {
                    classcoursecode: this.$route.query.code,
                    keyword: '',
                    status: '',
                    classcode: this.$route.query.classCode,
                    periodname: '',
                    periodcode: ''
                },
            },
            queryCache: {
                page: 1,
                pagesize: getTableDefaultPageSize(),
            },
            options: [
                {label: '未完成', value: 0},
                {label: '已完成', value: 10}
            ],
            exportParams: {
                condition: {
                    classcode: this.$route.query.classCode,
                    classcoursecode: '',
                    keyword: '',
                    periodcode: '',
                    periodname: '',
                    status: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            step: 1
        }
    },
    props: {
        // 课程code
        courseCode: {
            require: true,
            type: String,
        },
        // 班级code
        classCode: {
            require: true,
            type: String,
        }
    },
    created() {
        Object.assign(this.queryCache, deepClone(this.query))
        //  this.getCoursExamConfigList()
    },
    methods: {
        init() {
            if(this.step === 1){
                this.getStudentStudyListByCourse()
            }
        },
        reset() {
            this.query.condition.keyword = ''
            this.query.condition.status = ''
            this.queryCache.page = 1
            this.getStudentStudyListByCourse(this.query)
        },
        addClass(){
            this.$refs.AddTest.init()
        },
        // 获取考试配置列表
        async getStudentStudyListByCourse(param) {
            if (param) {
                this.queryCache.page = 1
            }
            Object.assign(this.queryCache, deepClone(param))
            this.loading = true
            try {
                const res = await getStudentStudyListByCourse(this.queryCache)
                console.log(res,'res配置')
                this.step++
                if (res.code === '000') {
                    this.testInfoList = res.data
                    this.total = res.pageinfo.rowcount
                }
                this.loading = false
            } catch {
                this.loading = false
            }
        },
        del(){

        },
        edit(row){
            this.$refs.AddTest.init(row.code)
        },
        // 导出学员学情列表
        // async exportStudentStudyList() {
        //     this.queryCache.condition.classcoursecode = this.courseCode
        //     await exportStudentStudyList(this.queryCache, '下载.xlsx')
        // },
        // 序号格式化
        indexFormatter(index) {
            return index + 1 + (this.queryCache.page - 1) * this.queryCache.pagesize
        },
        // 分页大小改变
        handePageSizeChange(e) {
            this.queryCache.page = 1
            this.queryCache.pagesize = e
            this.getStudentStudyListByCourse()
        },
        // 页面跳转
        curPageChange(e) {
            // this.queryCache.page = e
            // this.getStudentStudyListByCourse()
        },
        exportList(){
            this.exportParams.page = this.queryCache.page 
            this.exportParams.condition.classcoursecode = this.queryCache.condition.classcoursecode
            this.exportParams.condition.status = this.queryCache.status
            exportStudentStudyList(this.exportParams, '学员信息.xls').then(res => {
                console.log(res,'导出')
            })
        }
    },
}
</script>
<style lang="scss" scoped>
::v-deep .searchBox .el-input__inner{
    height: 36px!important;
}
.testContent{
    padding: 2px;
    .el-button {
        margin-bottom: 0 !important;
    }
    ::v-deep .el-input,
    .el-select {
        height: 36px !important;

        > .el-input {
            height: 36px !important;
        }
    }
}
</style>
